import React, { useEffect } from 'react';
import { useDropzone } from 'react-dropzone';

import {
  DropzoneStyled,
  RootStyled,
  DropzoneTitle,
  DropzoneSubtitle,
} from './styles';

export default function Dropzone({ setFiles, setToaster }) {
  const { acceptedFiles, getRootProps, getInputProps, fileRejections } =
    useDropzone({
      accept: {
        'application/pdf': ['.pdf'],
        'image/png': ['.png'],
        'image/jpeg': ['.jpeg', '.jpg'],
      },
    });

  useEffect(() => {
    if (fileRejections.length) {
      setToaster({
        open: true,
        msg: 'Formato inválido. O arquivo deve ser do tipo .pdf, .png, .jpg ou .jpeg',
      });
      setTimeout(() => setToaster({ open: false, msg: '' }), 5000);
    }
    setFiles((prev) => [...prev, ...acceptedFiles]);
  }, [acceptedFiles]);

  return (
    <RootStyled>
      <DropzoneStyled {...getRootProps()}>
        <input {...getInputProps()} />
        <DropzoneTitle component="h4" variant="h4">
          Arraste e solte a imagem ou clique para escolher os arquivos
        </DropzoneTitle>
        <DropzoneSubtitle component="p">
          Formatos aceitos: JPEG, PNG e PDF
        </DropzoneSubtitle>
      </DropzoneStyled>
    </RootStyled>
  );
}
